/* eslint-disable react/no-array-index-key */
/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable max-len */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/state-in-constructor */
import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import axios from 'axios';
import ls from 'local-storage';
import _ from 'lodash';
import IconButton from '@material-ui/core/IconButton';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import Badge from '@material-ui/core/Badge';
import LinearProgress from '@material-ui/core/LinearProgress';
import VisibilitySensor from 'react-visibility-sensor';
import OlsSearchAlpha from '../../container/OlsSearch/OlsSearchAlpha';
import OlsProductRow from '../../component/OlsProductRow/OlsProductRow';
import OlsCategorySelect from '../../container/OlsCategorySelect/OlsCategorySelect';
import OlsBottomNav from '../../container/OlsBottomNav/OlsBottomNav';
import OlsProductView from '../../container/OlsProductView/OlsProductView';
import OlsItemEdit from '../../container/OlsItemEdit/OlsItemEdit';
import PlaystoreLink from '../../component/PlaystoreLink/PlaystoreLink';

let isMounted = false;

const useStyles = (theme) => ({
  appBarWrapper: {
    backgroundColor: 'white',
  },
  appBar: {
    backgroundColor: theme.palette.primary.main,
    maxWidth: theme.palette.width.maxWidth,
    width: '100%',
    position: 'fixed',
    top: 0,
    left: 'auto',
    right: 'auto',
    paddingRight: '0px !important',
  },
  appBarTitle: {
    position: 'relative',
    display: 'block',
    fontWeight: 'bold',
    marginLeft: 0,
    width: '100%',
  },
  appToolbar: {
    height: 62,
    minHeight: 62,
    maxHeight: 62,
  },
  appBarRightIcon: {
    display: 'flex',
  },
  topWrapper: {
    backgroundColor: 'white',
    height: '100px',
    maxWidth: theme.palette.width.maxWidth,
    width: '100%',
    position: 'fixed',
    top: 62,
    left: 'auto',
    right: 'auto',
    zIndex: '1099',
  },
  content: {
    marginTop: 108,
    padding: 4,
    display: 'block',
    minHeight: 1000,
    '&::after': {
      content: '""',
      clear: 'both',
      display: 'table',
    },
  },
});

const { pathname } = window.location;
const arrPath = pathname.split('/');
const username = (arrPath && arrPath.length >= 3) ? arrPath[3] : '';

class Belanja extends Component {
  constructor(props) {
    super(props);
    this.state = {
      otl_info: ls.get(`${username}_info`) || {},
      order_info: {},
      item_list: [],
      loading: false,
      more: false,
      category_list: [],
      product_list: [],
      search_text: '',
      itemEdit: false,
      itemEditData: {},
      itemView: false,
      itemViewData: {},
    };
    this.isAlpha = true;
    this.categorySelected = '';
  }

  componentDidMount() {
    isMounted = true;
    this.setState({
      product_list: ls.get(`${username}_products`) || [],
      category_list: ls.get(`${username}_categorys`) || [],
    });

    this.doListLoad();

    const formdata2 = new FormData();
    formdata2.append('u', username);
    formdata2.append('last_count', 0);
    axios.post('https://eqiozmart.com/olsapi/product/product_otl_category_list/', formdata2).then((response) => {
      if (isMounted) {
        if (_.isArray(response.data.categorys)) {
          this.setState({
            category_list: response.data.categorys,
          });
          ls.set(`${username}_categorys`, response.data.categorys);
        }
      }
    });

    const lsShoppingCartOrderInfo = `${username}_ShoppingCart_OrderInfo`;
    const lsShoppingCartItemList = `${username}_ShoppingCart_ItemList`;
    const orderInfo = ls.get(lsShoppingCartOrderInfo);
    if (_.isObject(orderInfo)) {
      if (_.isString(orderInfo.order_uxid)) {
        this.setState({ order_info: orderInfo });
        const itemList = ls.get(lsShoppingCartItemList);
        if (_.isArray(itemList)) {
          this.setState({ item_list: itemList });
        }
      }
    }
    this.setState({ loading: true });
    axios.post(`https://eqiozmart.com/olsapi/olshop/order_info/${username}/`).then((response) => {
      if (isMounted) {
        this.setState({ loading: false });
        if (_.isObject(response.data.order_info)) {
          const orderInfoResp = response.data.order_info;
          if (_.isString(orderInfoResp.order_uxid)) {
            this.setState({ order_info: orderInfoResp });
            ls.set(lsShoppingCartOrderInfo, orderInfoResp);
          }
        }
        if (_.isArray(response.data.item_list)) {
          const itemListResp = response.data.item_list;
          this.setState({ item_list: itemListResp });
          ls.set(lsShoppingCartItemList, itemListResp);
        }
      }
    });

    axios.post(`https://eqiozmart.com/olsapi/otl/playstore/${username}/`).then((response) => {});
  }

  componentWillUnmount() {
    isMounted = false;
  }

  productViewOpen = (data) => {
    if (isMounted) {
      if (_.isObject(data)) {
        if (_.isString(data.product_uxid)) {
          const uxid = data.product_uxid;
          const productViewTemp = `${username}_product_${uxid}`;
          ls.set(productViewTemp, data);
          this.props.history.push(`/product/${uxid}`);
        }
      }
    }
  }

  handleCategorySelect = (value) => {
    if (isMounted) {
      this.categorySelected = value;
      this.doListLoad();
    }
  }

  handleSearchOnChange = (value) => {
    if (isMounted) {
      if(value.length){
        this.setState({
          search_text: value,
        });
        this.setState({ loading: true });
        const formdata = new FormData();
        formdata.append('u', username);
        formdata.append('category_name', this.categorySelected);
        formdata.append('search', value);
        formdata.append('last_count', 0);
        axios.post('https://eqiozmart.com/olsapi/product/product_otl_search/', formdata).then((response) => {
          if (isMounted) {
            this.setState({ loading: false });
            if (_.isArray(response.data.products)) {
              this.setState({
                product_list: response.data.products,
              });
            }
          }
        });
      } else {
        this.doListLoad();
      }
    }
  }

  handleSearchOnSubmit = (value) => {
    if (isMounted) {
      if(value.length){
        this.setState({
          search_text: value,
        });
        this.setState({ loading: true });
        const formdata = new FormData();
        formdata.append('u', username);
        formdata.append('category_name', this.categorySelected);
        formdata.append('search', value);
        formdata.append('last_count', 0);
        axios.post('https://eqiozmart.com/olsapi/product/product_otl_search/', formdata).then((response) => {
          if (isMounted) {
            this.setState({ loading: false });
            if (_.isArray(response.data.products)) {
              this.setState({
                product_list: response.data.products,
              });
            }
          }
        });
        window.scrollTo(0, 0);
      } else {
        this.doListLoad();
      }
    }
  }

  handleShoppingCartOpen = () => {
    if (isMounted) {
      const lsShoppingCartOrderInfo = `${username}_ShoppingCart_OrderInfo`;
      const lsShoppingCartItemList = `${username}_ShoppingCart_ItemList`;
      ls.set(lsShoppingCartOrderInfo, this.state.order_info);
      ls.set(lsShoppingCartItemList, this.state.item_list);
      this.props.history.push('/shoppingcart');
    }
  }

  doListLoad = () => {
    if (isMounted) {
      const lastCount = 0;
      this.setState({ loading: true });
      const formdata = new FormData();
      formdata.append('u', username);
      formdata.append('category_name', this.categorySelected);
      formdata.append('last_count', lastCount);
      if(this.isAlpha){
        axios.post('https://eqiozmart.com/olsapi/product/product_otl_list/', formdata).then((response) => {
          if (isMounted) {
            this.setState({ loading: false });
            if (_.isArray(response.data.products)) {
              if (_.size(response.data.products) > 0) {
                this.setState({
                  more: true,
                });
              } else {
                this.setState({
                  more: false,
                });
              }
              this.setState({
                product_list: response.data.products,
              });
              ls.set(`${username}_products`, response.data.products);
            }
          }
        });
      } else {
        axios.post('https://eqiozmart.com/olsapi/product/product_best_list/', formdata).then((response) => {
          if (isMounted) {
            this.setState({ loading: false });
            if (_.isArray(response.data.products)) {
              if (_.size(response.data.products) > 0) {
                this.setState({
                  more: true,
                });
              } else {
                this.setState({
                  more: false,
                });
              }
              this.setState({
                product_list: response.data.products,
              });
              ls.set(`${username}_products`, response.data.products);
            }
          }
        });
      }
      window.scrollTo(0, 0);
    }
  }

  doListMore = () => {
    if (isMounted) {
      const lastCount = _.size(this.state.product_list);
      const formdata = new FormData();
      formdata.append('u', username);
      formdata.append('category_name', this.categorySelected);
      formdata.append('last_count', lastCount);
      if(this.isAlpha){
        axios.post('https://eqiozmart.com/olsapi/product/product_otl_list/', formdata).then((response) => {
          if (isMounted) {
            if (_.isArray(response.data.products)) {
              if (_.size(response.data.products) > 0) {
                this.setState({
                  more: true,
                });
                const productList = _.unionBy(this.state.product_list, response.data.products, 'product_uxid');
                this.setState({
                  product_list: productList,
                });
              } else {
                this.setState({
                  more: false,
                });
              }
            }
          }
        });
      } else {
        axios.post('https://eqiozmart.com/olsapi/product/product_best_list/', formdata).then((response) => {
          if (isMounted) {
            if (_.isArray(response.data.products)) {
              if (_.size(response.data.products) > 0) {
                this.setState({
                  more: true,
                });
                const productList = _.unionBy(this.state.product_list, response.data.products, 'product_uxid');
                this.setState({
                  product_list: productList,
                });
              } else {
                this.setState({
                  more: false,
                });
              }
            }
          }
        });
      }
    }
  }

  doSearchMore = () => {
    if (isMounted) {
      const lastCount = _.size(this.state.product_list);
      const formdata = new FormData();
      formdata.append('u', username);
      formdata.append('category_name', this.categorySelected);
      formdata.append('search', this.state.search_text);
      formdata.append('last_count', lastCount);
      axios.post('https://eqiozmart.com/olsapi/product/product_otl_search/', formdata).then((response) => {
        if (isMounted) {
          if (_.isArray(response.data.products)) {
            if (_.size(response.data.products) > 0) {
              this.setState({
                more: true,
              });
              const productList = _.unionBy(this.state.product_list, response.data.products, 'product_uxid');
              this.setState({
                product_list: productList,
              });
            } else {
              this.setState({
                more: false,
              });
            }
          }
        }
      });
    }
  }

  handleLoadMore = (isMore) => {
    if (isMore) {
      this.setState({
        more: false,
      });
      if (_.isEmpty(this.state.search_text)) {
        this.doListMore();
      } else {
        this.doSearchMore();
      }
    }
  }

  handleItemEditClose = () => {
    if (isMounted) {
      this.setState({
        itemEdit: false,
      });
    }
  }

  handleItemEditDelete = (fields) => {
    if (isMounted) {
      this.setState({
        itemEdit: false,
      });

      const lsShoppingCartOrderInfo = `${username}_ShoppingCart_OrderInfo`;
      const lsShoppingCartItemList = `${username}_ShoppingCart_ItemList`;
      this.setState({ loading: true });
      const formdata = new FormData();
      formdata.append('item_uxid', fields.item_uxid);
      formdata.append('item_amount', fields.item_amount);
      formdata.append('item_note', fields.item_note);
      axios.post('https://eqiozmart.com/olsapi/olshop/item_delete/', formdata).then((response) => {
        if (isMounted) {
          this.setState({ loading: false });
          if (_.isObject(response.data.order_info)) {
            const orderInfoResp = response.data.order_info;
            if (_.isString(orderInfoResp.order_uxid)) {
              this.setState({ order_info: orderInfoResp });
              ls.set(lsShoppingCartOrderInfo, orderInfoResp);
            }
          }
          if (_.isArray(response.data.item_list)) {
            const itemListResp = response.data.item_list;
            this.setState({ item_list: itemListResp });
            ls.set(lsShoppingCartItemList, itemListResp);
          }
          //= toast start
          if (_.isString(response.data.status)) {
            if (response.data.status === 'success') {
              if (_.isString(response.data.message)) {
                const { message } = response.data;
                this.toastShow('success', message);
              }
            } else if (_.isString(response.data.message)) {
              const { message } = response.data;
              this.toastShow('error', message);
            }
          }
          //= toast end
        }
      });
    }
  }

  handleItemEditSave = (fields) => {
    if (isMounted) {
      this.setState({
        itemEdit: false,
      });

      const lsShoppingCartOrderInfo = `${username}_ShoppingCart_OrderInfo`;
      const lsShoppingCartItemList = `${username}_ShoppingCart_ItemList`;
      this.setState({ loading: true });
      const formdata = new FormData();
      formdata.append('item_uxid', fields.item_uxid);
      formdata.append('item_amount', fields.item_amount);
      formdata.append('item_note', fields.item_note);
      axios.post('https://eqiozmart.com/olsapi/olshop/item_update/', formdata).then((response) => {
        if (isMounted) {
          this.setState({ loading: false });
          if (_.isObject(response.data.order_info)) {
            const orderInfoResp = response.data.order_info;
            if (_.isString(orderInfoResp.order_uxid)) {
              this.setState({ order_info: orderInfoResp });
              ls.set(lsShoppingCartOrderInfo, orderInfoResp);
            }
          }
          if (_.isArray(response.data.item_list)) {
            const itemListResp = response.data.item_list;
            this.setState({ item_list: itemListResp });
            ls.set(lsShoppingCartItemList, itemListResp);
          }
          //= toast start
          if (_.isString(response.data.status)) {
            if (response.data.status === 'success') {
              if (_.isString(response.data.message)) {
                const { message } = response.data;
                this.toastShow('success', message);
              }
            } else if (_.isString(response.data.message)) {
              const { message } = response.data;
              this.toastShow('error', message);
            }
          }
          //= toast end
        }
      });
    }
  }

  handleItemViewOpen = (productOpen) => {
    if (isMounted) {
      this.setState({
        itemViewData: productOpen,
        itemView: true,
      });
    }
  }

  handleItemViewClose = () => {
    if (isMounted) {
      this.setState({
        itemView: false,
      });
    }
  }

  handleItemViewBuy = (productBuy) => {
    if (isMounted) {
      this.setState({
        itemView: false,
      });
      const usrInfo = ls.get('usr_info');
      if (_.isString(usrInfo.usr_realname)) {
        if (_.isString(this.state.order_info.order_uxid)) { // untuk memastikan object order terload dengan benar
          if (_.isString(productBuy.product_uxid)) { // untuk memastikan object product terload dengan benar
            const item = _.find(this.state.item_list, { item_product_uxid: productBuy.product_uxid });
            if (_.isObject(item)) {
              if (this.state.order_info.order_step === 'CREATE') {
                this.setState({
                  itemEdit: true,
                  itemEditData: item,
                });
              } else {
                this.toastShow('error', 'Tidak dapat beli produk ini');
              }
            } else {
              const lsShoppingCartOrderInfo = `${username}_ShoppingCart_OrderInfo`;
              const lsShoppingCartItemList = `${username}_ShoppingCart_ItemList`;
              this.setState({ loading: true });
              const formdata = new FormData();
              formdata.append('item_order_uxid', this.state.order_info.order_uxid);
              formdata.append('item_product_uxid', productBuy.product_uxid);
              formdata.append('item_amount', 1);
              formdata.append('item_note', '');
              axios.post('https://eqiozmart.com/olsapi/olshop/item_add/', formdata).then((response) => {
                if (isMounted) {
                  this.setState({ loading: false });
                  if (_.isObject(response.data.order_info)) {
                    const orderInfoResp = response.data.order_info;
                    if (_.isString(orderInfoResp.order_uxid)) {
                      this.setState({ order_info: orderInfoResp });
                      ls.set(lsShoppingCartOrderInfo, orderInfoResp);
                    }
                  }
                  if (_.isArray(response.data.item_list)) {
                    const itemListResp = response.data.item_list;
                    this.setState({ item_list: itemListResp });
                    ls.set(lsShoppingCartItemList, itemListResp);
                  }
                  //= toast start
                  if (_.isString(response.data.status)) {
                    if (response.data.status === 'success') {
                      if (_.isString(response.data.message)) {
                        const { message } = response.data;
                        this.toastShow('success', message);
                      }
                    } else if (_.isString(response.data.message)) {
                      const { message } = response.data;
                      this.toastShow('error', message);
                    }
                  }
                  //= toast end
                  const itemEd = _.find(this.state.item_list, { item_product_uxid: productBuy.product_uxid });
                  if (_.isObject(itemEd)) {
                    if (this.state.order_info.order_step === 'CREATE') {
                      this.setState({
                        itemEdit: true,
                        itemEditData: itemEd,
                      });
                    } else {
                      this.toastShow('error', 'Tidak dapat beli produk ini');
                    }
                  }
                }
              });
            }
          }
        }
      } else {
        this.props.history.push('/login');
      }
    }
  };

  handleSearchIconOnSort= (value) => {
    if (isMounted) {
      this.isAlpha = value;
      this.doListLoad();
    }
  }

  render() {
    const { classes } = this.props;
    return (
      <div style={{ paddingBottom: 56 }}>
        <div className={classes.appBarWrapper}>
          <AppBar className={classes.appBar}>
            <Toolbar className={classes.appToolbar}>
              <Typography className={classes.appBarTitle} variant="h6" noWrap>
                Belanja
              </Typography>
              <div className={classes.appBarCart}>
                <IconButton color="inherit" onClick={this.handleShoppingCartOpen}>
                  <Badge badgeContent={_.size(this.state.item_list)} color="secondary">
                    <ShoppingCartIcon />
                  </Badge>
                </IconButton>
              </div>
            </Toolbar>
            <div style={{ marginBottom: -5, height: 5 }}>
              <LinearProgress style={this.state.loading ? {} : { display: 'none' }} />
            </div>
          </AppBar>
        </div>
        <div className={classes.topWrapper}>
          <OlsCategorySelect data={this.state.category_list} onSelect={this.handleCategorySelect} />
          <OlsSearchAlpha onChange={this.handleSearchOnChange} onSubmit={this.handleSearchOnSubmit} onSort={this.handleSearchIconOnSort} />
        </div>
        <div className={classes.content}>
          {
            this.state.product_list.map((product, index) => <OlsProductRow key={index} data={product} onSelect={(data) => this.handleItemViewOpen(data)} />)
          }
        </div>
        <VisibilitySensor onChange={this.handleLoadMore}>
          <div style={{ height: 5 }}>
            <LinearProgress style={this.state.more ? {} : { display: 'none' }} />
          </div>
        </VisibilitySensor>
        <PlaystoreLink url={this.state.otl_info.otl_playstore ? this.state.otl_info.otl_playstore : ''} />
        <OlsProductView data={this.state.itemViewData} username={username} onClose={this.handleItemViewClose} onBuy={this.handleItemViewBuy} open={this.state.itemView} />
        <OlsItemEdit data={this.state.itemEditData} onClose={this.handleItemEditClose} onSave={this.handleItemEditSave} onDelete={this.handleItemEditDelete} open={this.state.itemEdit} />
        <OlsBottomNav value="belanja" />
      </div>
    );
  }
}

export default withStyles(useStyles)(Belanja);
